
import './App.css';
import React from 'react';
import Navigation from './Navbar/Navbar'
import 'bootstrap/dist/css/bootstrap.min.css';
import Home from './Home/Home'
import Dashboard from './Dashboard/Dashboard'
import StockManagement from './StockManagement/StockManagement'
import AddAgent from './AddAgent/AddAgent'
import { Routes, Route } from "react-router-dom";
import ListSignout from './ListSignouts/ListSignouts'
import AddSignout from './AddSignout/AddSignout'
import AddEquipment from './AddEquipment/AddEquipment'
import { HashRouter } from 'react-router-dom'
import SignoutDetails from './SignoutDetails/SignoutDetails';
import Login from './Login/Login';
import Admin from './Admin/Admin';
import Register from './Register/Register';
import axios from 'axios';


//Add react routes
function App() {
  const [hasUsers, setHasUsers] = React.useState(null);
  const [isLoading, setIsLoading] = React.useState(true);

  React.useEffect(() => {
    const checkUsers = async () => {
      try {
        const response = await axios.get('/api/check-users');
        setHasUsers(response.data.hasUsers);
      } catch (error) {
        console.error('Error checking users:', error);
        // If we can't check, assume users exist to avoid breaking existing installations
        setHasUsers(true);
      } finally {
        setIsLoading(false);
      }
    };

    checkUsers();
  }, []);

  if (isLoading) {
    return (
      <div className="d-flex justify-content-center align-items-center min-vh-100">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  return (
    <HashRouter>
      <Routes>
        <Route path="/register" element={<Register />} />
        {!hasUsers ? (
          <Route path="*" element={<Register />} />
        ) : (
          <>
            <Route path="/login" element={<Login />} />
            <Route path="/" element={<Dashboard />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/inventory" element={<Home />} />
            <Route path="/stock" element={<StockManagement />} />
            <Route path="/addagent" element={<AddAgent />} />
            <Route path="/listsignouts" element={<ListSignout />} />
            <Route path='/addsignout' element={<AddSignout />} />
            <Route path="/inv" element={<AddEquipment />} />
            <Route path="/inv/signout" element={<SignoutDetails />} />
            <Route path="/admin" element={<Admin />} />
          </>
        )}
      </Routes>
    </HashRouter>
  );
}

export default App;
